module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pembayaran"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("List Ticket Usage")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("List Ticket Usage")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.ticketUsageList,
      "headers": _vm.headers,
      "has-action": false,
      "has-custom-search": true,
      "has-custom-pagination": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.detailTicketUsage()
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key],
        }
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Ticket Usage")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d479096e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pembayaran/components/TicketUsage.vue
// module id = 2033
// module chunks = 1